import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertDialog } from '@/components/AlertDialog';
import { ConfirmModal } from '@/components/Modal/ConfirmModal';
import { useIsMobile } from '@/hooks/useIsMobile';
import { ButtonVariant } from '@/types/components';

const singleActionClass =
  'font-system text-[17px]/[22px] font-semibold tracking-[-0.41px] text-alert-action';

interface Props {
  isOpen: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  hideCancel?: boolean;
  isPending?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmDialog: React.FC<Props> = ({
  isOpen,
  title,
  message,
  confirmLabel,
  hideCancel = false,
  isPending = false,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <AlertDialog
        isOpen={isOpen}
        title={title}
        message={message}
        confirmLabel={confirmLabel ?? t('global.close')}
        hideCancel={hideCancel}
        isPending={isPending}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    );
  }

  return (
    <ConfirmModal
      simpleView
      isOpen={isOpen}
      title={title}
      description={message}
      confirmLabel={confirmLabel ?? t('global.ok')}
      confirmVariant={
        hideCancel ? ButtonVariant.Secondary : ButtonVariant.Primary
      }
      confirmClassName={hideCancel ? singleActionClass : ''}
      hideCancel={hideCancel}
      isPending={isPending}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
